import { render, staticRenderFns } from "./RouteItem.vue?vue&type=template&id=474182c6&scoped=true"
import script from "./RouteItem.vue?vue&type=script&lang=ts"
export * from "./RouteItem.vue?vue&type=script&lang=ts"
import style0 from "../style.scss?vue&type=style&index=0&id=474182c6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474182c6",
  null
  
)

export default component.exports